<template>
  <div id="app">
    <Header v-show="indexOfPath(path)"></Header>
    <router-view></router-view>
    <Footer v-show="indexOfPath(path)"></Footer>
    <GoTop v-show="indexOfPath(path)"></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      path: "",
    };
  },
  // 判断路由
  mounted() {
    this.path = this.$route.path;
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
  },
  methods: {
    indexOfPath(path) {
      if (path.indexOf("/admin") != -1) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue